import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=636f1239&scoped=true&"
import script from "./file-preview.vue?vue&type=script&lang=js&"
export * from "./file-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f1239",
  null
  
)

export default component.exports